import moment from "moment";

export const formatDate = (date = null, format = "MM/DD/YYYY") => {
  if (!date) return "";
  return moment(new Date(date)).format(format);
};